import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import CatalogFilterItem from '@/domains/catalog/components/CatalogFilterItem.vue';

interface Props {
  filters?: any[];
  value?: any;
  disabled?: boolean;
}
interface Emits {
  (e: 'input', data: Props['value']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogFilter',
  props: {
    filters: { default: () => [] },
    value: { default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { filters: any[], value: any, disabled: boolean };

const MAX_ITEMS = 5;





const isCollapsed = ref(true);

const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    if (!props.disabled) emit('input', newValue);
  },
});

const shouldCollapsed = computed(() => props.filters.length > MAX_ITEMS);
const localFilters = computed(() => {
  if (shouldCollapsed.value && isCollapsed.value)
    return props.filters.slice(0, MAX_ITEMS);
  return props.filters;
});
const collapsedCount = computed(() => props.filters.length - MAX_ITEMS);

const isFeatureFilter = (filter: any) => {
  return typeof filter.id !== 'string';
};

const getValueKey = (filter: any) =>
  isFeatureFilter(filter) ? 'filters' : filter.id;

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
};

return { __sfc: true,MAX_ITEMS, props, emit, isCollapsed, valueLocal, shouldCollapsed, localFilters, collapsedCount, isFeatureFilter, getValueKey, toggleCollapse, CatalogFilterItem }
}

})